import React from "react";
import ReactDOM from "react-dom/client";
// Änderung: Wir lassen die Endung weg. TS sucht automatisch nach .tsx oder .jsx
import App from "@/App";
import "@/index.css";
import ErrorBoundary from "@/components/ErrorBoundary";
import "@/lib/i18n";
import { initWebVitals } from "@/lib/webVitals";
// import { registerServiceWorker } from "@/lib/serviceWorker";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/lib/queryClient";

import { initSentry } from "@/lib/sentry";

// Sentry must be initialized before any component renders so that
// errors thrown during lazy-chunk loading are captured too.
initSentry();

initWebVitals();
// Temporarily disabled to avoid stale cached bundles after hosting migration.
// Re-enable once Cloudflare delivery is fully stable.
// registerServiceWorker();

const rootElement = document.getElementById("root") as HTMLElement;

if (!rootElement) {
  console.error("FATAL: Element mit ID 'root' nicht gefunden!");
  document.body.innerHTML =
    '<div style="color:red; padding:20px;">Fataler Fehler: Root-Element fehlt. Bitte Seite neu laden.</div>';
} else {
  try {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
          {import.meta.env.DEV ? (
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
          ) : null}
        </QueryClientProvider>
      </React.StrictMode>
    );
  } catch (err) {
    console.error("Fehler beim Rendern der Root-App:", err);
  }
}
